import { render, staticRenderFns } from "./HistoryJobsDirections.vue?vue&type=template&id=635e523a&scoped=true&"
import script from "./HistoryJobsDirections.vue?vue&type=script&lang=js&"
export * from "./HistoryJobsDirections.vue?vue&type=script&lang=js&"
import style0 from "./HistoryJobsDirections.vue?vue&type=style&index=0&id=635e523a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e523a",
  null
  
)

export default component.exports